import styled from "@emotion/styled";

import { FakePreview } from "@skilitics/designer-ui-components";

export const MediaIcon = styled(FakePreview)`
  filter: grayscale(100%);
`;
